import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractAction from "./AbstractAction.js";
import InputValueDropdownAction from "./InputValueDropdownAction.js";

/**
 * Action adding standard texts in the editor.
 *
 * @param {PeriodReportDefaultText[]} defaultTexts - Pre-existing
 * standard texts that can be inserted in the editor to ease filling
 * the period report comments
 */
export default class DefaultTextAction extends AbstractAction {
	constructor({ defaultTexts = [] }) {
		super(...arguments);

		this._dropdownAction =
			defaultTexts &&
			new InputValueDropdownAction({
				label: _("Texts"),
				items: this._makeDefaultTextItems(defaultTexts),
				order: 100,
				dataTestName: "standard-texts",
			});
	}

	ensureDropdownMenuItemBuilder(builder) {
		this._dropdownAction?.ensureDropdownMenuItemBuilder(builder);
	}

	getMenuItems(...spec) {
		return this._dropdownAction?.getMenuItems(...spec);
	}

	_makeDefaultTextItems(defaultTexts) {
		return defaultTexts.map((defaultText) =>
			this._makeDefaultTextItem(defaultText),
		);
	}

	_makeDefaultTextItem(defaultText) {
		return {
			label: defaultText.getLabel(),
			match: (string) => defaultText.match(string),
			nodeSpec: {
				type: "html",
				content: defaultText.getContent(),
			},
		};
	}
}
